import moment from 'moment'

export const sortByDateAsc = (records, sortAttr) => {
  return records.sort((a,b) => {
    return moment(a[sortAttr]).unix() - moment(b[sortAttr]).unix()
  });
};